import { useLocation, useParams } from 'react-router-dom'

export function useActiveGroupName() {
  const { pathname } = useLocation()
  const { groupname } = useParams()

  if (!groupname || !pathname.includes('/g/')) return null

  return groupname
}
